export const STARTING_VAULT_ID = 1
export const STARTING_ADAPTER_ID = 1
